import { Section } from "../../components/Section";
import { Scriptbox } from "../../components/Scriptbox";

export function Request({ takeref }: { takeref: any }) {
  return (
    <Section heading="Get Your API Key" takeref={takeref}>
      <p>
        This is the GET API for fetching your API Key. Using this endpoint, you
        can securely retrieve your API Key, which is essential for
        authentication and integration with external services.
      </p>

      <h3>Endpoint</h3>
      <p>
        <code>https://internals.pointx.one/externals/v1/get-api-keys/?phone=YOUR_Organization_Number</code>
      </p>

      <h3>Method</h3>
      <p>
        <b>GET</b>
      </p>

      <h3>Request Headers</h3>
      <p>
        Provide Your Organization phone number as params 
      </p>
      {/* <Scriptbox
        codedata={[
          `"Authorization": "Api-Key YOUR_API_KEY YOUR_API_KEY"`
        ]}
      ></Scriptbox> */}

      <h3>Response</h3>
      <p>If the request is successful, the API returns a JSON response:</p>
      <Scriptbox
        codedata={[
          `{
    "error": false,
    "msg": "API Keys",
    "api_keys": "gAAAAABnasYx3b2fIKKsOPFHgQ2sMrBFTm1zgeSEkk-eaqE2eBfalbl5LRZJv4msmr3ogGE4E9bbFLREfeZUR22jFu0rrwAVRb_b6q5wdoXcSw_Jc0VeU2ZXBJsu2XGdPzZhN4zREnwz"
}`
        ]}
        codelanguage={["json"]}
      ></Scriptbox>

      <h3>Response Details</h3>
      <ul>
        <li>
          <b>error:</b> Indicates whether there was an error. <code>false</code>{" "}
          means the request was successful.
        </li>
        <li>
          <b>msg:</b> A brief message summarizing the response, in this case{" "}
          <code>"API Keys"</code>.
        </li>
        <li>
          <b>api_keys:</b> The encrypted API key associated with your account.
        </li>
      </ul>

      <h3>Example Request</h3>
      <Scriptbox
        codedata={[
          `curl -X GET \\
  https://internals.pointx.one/externals/v1/get-Api-Key  \\
  -H "Authorization: Api-Key YOUR_API_KEY"`
        ]}
        codelanguage={["bash"]}
      ></Scriptbox>

      <h3>Notes</h3>
      <ul>
        <li>
          Always store the API Key securely. Avoid exposing it in client-side
          code or public repositories.
        </li>
        <li>
          The <code>api_keys</code> value is encrypted for additional security.
          Handle it appropriately in your application.
        </li>
        <li>
          If the response contains <code>"error": true</code>, ensure proper
          error handling in your integration.
        </li>
      </ul>
    </Section>
  );
}
